import React from "react";
import SEO from "../common/SEO";
import HeaderTwo from "../common/header/HeaderTwo";
import FooterFour from "../common/footer/FooterThree";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import Separator from "../elements/separator/Separator";
import Brand from "../elements/brand/Brand";

const Capabilities = () => {
  return (
    <>
      <SEO title="LearningQ | Government Subcontracting Capabilities" />
      <main className="page-wrapper">
        <HeaderTwo btnStyle="btn-small" HeaderSTyle="header-transparent" />

        <div
          className="slider-area slider-style-3 height-750 bg_image bg_image_fixed"
          data-black-overlay="2"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-image-1.jpg)`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mt_md--50 mt_sm--50 mt_lg--30">
                <div className="inner pt--60 text-left">
                  <h1 className="title pt--60 theme-gradient">
                    Government Subcontracting Capabilities
                  </h1>
                  <p className="description mt--20">
                    Expertise in delivering customizable microlearning solutions
                    for government contracts with measurable outcomes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className=" bg_image bg_image_fixed rn-section-gap"
          data-white-overlay="6"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-image-1.jpg)`,
          }}
        >
          <div className="container">
            <h3 className="title text-center" style={{ color: "#FFF" }}>
              Key Partners
            </h3>
            <Brand />
          </div>
        </div>
        <div className="container">
          <SectionTitle
            textAlign="text-center"
            radiusRounded=""
            subtitle="Why Choose LearningQ"
            title="Overview"
          />
          <p>
            The leadership team behind LearningQ brings decades of combined
            expertise in education, healthcare, software engineering, and user
            experience design. Their work is united by a commitment to advancing
            microlearning technology, improving access and outcomes for a wide
            variety of learners and applications. The team has led impactful
            initiatives in the public and private space, ranging from national
            health campaigns to innovative educational programs. Our work has
            spanned partnerships with the State of Florida to Tenet Health. Our
            team contributes unique strengths—visionary leadership, robust
            technical development, and learner-focused design—ensuring that
            LearningQ remains adaptable, inclusive, and results-driven.
            Together, we are reshaping how modern education is delivered and
            experienced.
          </p>
        </div>
        <div className="rn-section-gap">
          <div className="container">
            <SectionTitle
              textAlign="text-center"
              radiusRounded=""
              subtitle="Why Choose LearningQ"
              title="Differentiators"
            />
            <ul className="list-unstyled text-center">
              <li>
                Microlearning tools increasing accessibility, retention, and
                application
              </li>
              <li>
                Development of AI-enhanced functionality will modernize the
                platform by enabling rapid content creation, personalized
                coaching and coursework, and scalable learner analytics.
              </li>
              <li>Flexible, mobile-friendly learning solutions</li>
              <li>
                Collaboration with behavioral health, workforce, and educational
                organizations
              </li>
              <li>
                Customizable content with built-in metrics and feedback loops
              </li>
              <li>23% average skill increase after 6 weeks</li>
              <li>93% learner completion rate</li>
            </ul>
          </div>
        </div>

        <Separator />

        <div className="rn-section-gap">
          <div className="container">
            <SectionTitle
              textAlign="text-center"
              radiusRounded=""
              subtitle="Demonstrated Success"
              title="Past Performance"
            />
            <ul className="list-unstyled text-center">
              <li>
                Microlearning pilots for employment readiness with state
                agencies
              </li>
              <li>Digital training addressing social determinants of health</li>
              <li>Scalable education tools for community organizations</li>
              <li>Measurable gains in engagement, confidence, and skills</li>
            </ul>
          </div>
        </div>

        <Separator />

        <div className="rn-section-gap">
          <div className="container">
            <SectionTitle
              textAlign="text-center"
              radiusRounded=""
              subtitle="Contracting Details"
              title="Company Data"
            />
            <ul className="list-unstyled text-center">
              <li>UEI: GYKNYPN2YAY7</li>
              <li>CAGE CODE: 9BL51</li>
              <li>
                NAICS Codes:
                <ul>
                  <li>92400 – Educational Training Services</li>
                  <li>92416 – Course Development</li>
                  <li>92486 – VOC Training</li>
                  <li>
                    611430 – Professional and Management Development Training
                  </li>
                  <li>
                    624190 – Behavior Health Support and Digital Education
                  </li>
                  <li>611710 – Educational Support Services</li>
                  <li>611513 – Apprenticeship Training</li>
                  <li>624310 – Vocational Rehabilitation Services.</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <Separator />

        <div className="rn-section-gap">
          <div className="container text-center">
            <SectionTitle
              textAlign="text-center"
              radiusRounded=""
              subtitle="Get in Touch"
              title="Contact"
            />
            <p>
              <strong>Amy Fox</strong>
              <br />
              Co-Founder and CEO
              <br />
              Phone: 703-600-9758
              <br />
              Email: <a href="mailto:afox@learningq.org">afox@learningq.org</a>
              <br />
              Website: <a href="https://www.learningq.org">learningq.org</a>
            </p>
          </div>
        </div>

        <FooterFour />
      </main>
    </>
  );
};

export default Capabilities;
